import React, { forwardRef } from "react";
import ReactDOM from "react-dom";
import { Paper, Stack, Typography, Button } from "@mui/material";

const SharePopup = forwardRef(({ sharePos, getShareLinks, onClose }, ref) => {
  const content = (
    <Paper
      ref={ref}
      sx={{
        position: "absolute",
        top: sharePos.top,
        left: sharePos.left,
        p: 2,
        zIndex: 1300,
        boxShadow: 6,
        minWidth: 160,
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        Share via:
      </Typography>
      <Stack spacing={1}>
        {Object.entries(getShareLinks()).map(([name, href]) => (
          <Button
            key={name}
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            variant="outlined"
            onClick={onClose} // Close when clicked
          >
            {name}
          </Button>
        ))}
      </Stack>
    </Paper>
  );

  return ReactDOM.createPortal(content, document.body);
});

SharePopup.displayName = "SharePopup";
export default SharePopup;
